import { Flex, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

export const Error = () => {
	return (
		<Flex
			flexDirection="column"
			height="100vh"
			justifyContent="center"
			alignItems="center"
		>
			<Text
				fontSize={{ base: '30px', md: '40px' }}
				textTransform="uppercase"
			>
				Page not found
			</Text>
			<Flex
				fontSize="100px"
				fontWeight="bold"
				color="cartridge.red"
			>
				404
			</Flex>

			<Flex fontSize="16px">
				Click
				<Text
					m="0 5px"
					color="cartridge.red"
					_hover={{ opacity: 0.9 }}
				>
					<Link to="/">here</Link>
				</Text>
				to return to Homepage{' '}
			</Flex>
		</Flex>
	);
};
